export default __webpack_public_path__ + "static/front-of-shibuya-station-4759f35f5edeece85da3ce77e4ea97ac.jpg";